<template>
  <div class="about">
    <main>
      <div class="page-header pb-10 page-header-dark bg-gradient-primary-to-secondary">
        <div class="container">
          <div class="page-header-content">
            <h1 class="page-header-title">
              <div class="page-header-icon">
                <i data-feather="activity"></i>
              </div>
              <span>FAQs</span>
            </h1>
            <!--  <div class="page-header-subtitle">Support Ticketing Reports</div> -->
          </div>
        </div>
      </div>
      <div class="container mt-n10">
        <div class="row">
          <div class="col-md-12">
            <div class="card mb-4">
              <div class="card-body">
                <div class="accordion" id="accordionExample">
                  <div class="card" v-for="(item, index) in faqs" :key="index">
                    <div class="card-header" :id="'heading'+index">
                      <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="true" :aria-controls="'collapse'+index">
                          <b>{{item.question}}</b>
                        </button>
                      </h2>
                    </div>

                    <div :id="'collapse'+index" class="collapse" :aria-labelledby="'heading'+index" data-parent="#accordionExample">
                      <div class="card-body" v-html="item.answer"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Faq",

  data() {
    return {
      faqs: []
    };
  },

  mounted() {
    let loading = this.$loading.show();
    axios.get("/faqs").then(res => {
      this.faqs = res.data.faqs;
      loading.hide();
    });
  }
};
</script>